<script>
  import LanguageSwitcher from '/Atoms/LanguageSwitcher'

  export let zIndex
</script>


<div class="circle" style="z-index: {zIndex}">

</div>
<div class="text" style="z-index: {zIndex}">
  <LanguageSwitcher>
    <span slot="en">
      en
    </span>
    <span slot="de">
      de
    </span>
  </LanguageSwitcher>
</div>


<style lang="scss">
  .circle, .text {
    position: fixed;
    left: 20px;
    bottom: 20px;
    @include media-small {
      left: 10px;
      bottom: 10px;
    }
  }
  .circle {
    mix-blend-mode: difference;
    background: radial-gradient(circle at center, $color-mint 0, $color-mint 25%, transparent 70%);
    border-radius: 50%;
    width: 60px;
    height: 60px;
    @include media-small {
      width: 40px;
      height: 40px;
    }
  }
  .text {
    @include typo-grotesk-title-captions-20;

    text-align: center;

    width: 60px;
    line-height: 60px;
    @include media-small {
      width: 40px;
      line-height: 40px;
    }

    span {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

</style>